"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var FbaWindermere_exports = {};
__export(FbaWindermere_exports, {
  FbaWindermere: () => FbaWindermere
});
module.exports = __toCommonJS(FbaWindermere_exports);
var import_topo_map = require("@cartographerio/topo-map");
var import_core = require("../../core/index.js");
const phosphorousBuckets = [
  (0, import_topo_map.rangeBucket)(null, 4e-3, import_topo_map.marker.numeric(11 / 11, 120)),
  (0, import_topo_map.rangeBucket)(4e-3, 5e-3, import_topo_map.marker.numeric(10 / 11, 120)),
  (0, import_topo_map.rangeBucket)(5e-3, 75e-4, import_topo_map.marker.numeric(9 / 11, 120)),
  (0, import_topo_map.rangeBucket)(75e-4, 0.01, import_topo_map.marker.numeric(8 / 11, 120)),
  (0, import_topo_map.rangeBucket)(0.01, 0.02, import_topo_map.marker.numeric(7 / 11, 120)),
  (0, import_topo_map.rangeBucket)(0.02, 0.03, import_topo_map.marker.numeric(6 / 11, 120)),
  (0, import_topo_map.rangeBucket)(0.03, 0.04, import_topo_map.marker.numeric(5 / 11, 120)),
  (0, import_topo_map.rangeBucket)(0.04, 0.05, import_topo_map.marker.numeric(4 / 11, 120)),
  (0, import_topo_map.rangeBucket)(0.05, 0.1, import_topo_map.marker.numeric(3 / 11, 120)),
  (0, import_topo_map.rangeBucket)(0.1, 0.2, import_topo_map.marker.numeric(2 / 11, 120)),
  (0, import_topo_map.rangeBucket)(0.2, 0.3, import_topo_map.marker.numeric(1 / 11, 120)),
  (0, import_topo_map.rangeBucket)(0.3, null, import_topo_map.marker.numeric(0 / 11, 120))
];
const nitrateBuckets = [
  (0, import_topo_map.rangeBucket)(null, 0.02, import_topo_map.marker.numeric(11 / 11, 200)),
  (0, import_topo_map.rangeBucket)(0.02, 0.1, import_topo_map.marker.numeric(10 / 11, 200)),
  (0, import_topo_map.rangeBucket)(0.1, 0.2, import_topo_map.marker.numeric(9 / 11, 200)),
  (0, import_topo_map.rangeBucket)(0.2, 0.3, import_topo_map.marker.numeric(8 / 11, 200)),
  (0, import_topo_map.rangeBucket)(0.3, 0.4, import_topo_map.marker.numeric(7 / 11, 200)),
  (0, import_topo_map.rangeBucket)(0.4, 0.5, import_topo_map.marker.numeric(6 / 11, 200)),
  (0, import_topo_map.rangeBucket)(0.5, 0.75, import_topo_map.marker.numeric(5 / 11, 200)),
  (0, import_topo_map.rangeBucket)(0.75, 1, import_topo_map.marker.numeric(4 / 11, 200)),
  (0, import_topo_map.rangeBucket)(1, 1.5, import_topo_map.marker.numeric(3 / 11, 200)),
  (0, import_topo_map.rangeBucket)(1.5, 2, import_topo_map.marker.numeric(2 / 11, 200)),
  (0, import_topo_map.rangeBucket)(2, null, import_topo_map.marker.numeric(1 / 11, 200))
];
const FbaWindermere = (0, import_core.mapSchemaWithDefaults)({
  mapId: (0, import_topo_map.unsafeMapId)("FbaWindermere"),
  title: "Windermere",
  layers: [
    (0, import_topo_map.pointLayer)({
      layerId: (0, import_topo_map.unsafeMapLayerId)("FbaWindermere"),
      title: "Windermere",
      source: (0, import_core.cartographerSourceWithDefaults)({
        layerId: (0, import_topo_map.unsafeMapLayerId)("FbaWindermere"),
        attribution: []
      }),
      defaultAttribute: "temperature",
      defaultZOrder: "timestamp",
      attributes: [
        (0, import_topo_map.attributeGroup)({
          label: "Survey",
          attributes: [
            (0, import_topo_map.teamAttr)("teamId", "Team"),
            (0, import_topo_map.surveyAttr)("surveyId", "Survey"),
            (0, import_topo_map.timestampAttr)({
              attributeId: "timestamp",
              label: "Date/Time",
              buckets: "auto"
            })
          ]
        }),
        (0, import_topo_map.attributeGroup)({
          label: "Site",
          attributes: [
            (0, import_topo_map.stringAttr)({
              attributeId: "siteName",
              label: "Name",
              buckets: "auto"
            }),
            // stringAttr({ attributeId: "siteDescription", label: "Description", buckets: "auto", }),
            (0, import_topo_map.stringAttr)({
              attributeId: "lakeOrRiver",
              label: "Lake/River",
              buckets: [(0, import_topo_map.lookupBucket)("Lake", import_topo_map.marker.fromColor("#27b6f3")), (0, import_topo_map.lookupBucket)("River", import_topo_map.marker.fromColor("#27bf57"))]
            })
          ]
        }),
        (0, import_topo_map.attributeGroup)({
          label: "Measured Parameters",
          attributes: [
            (0, import_topo_map.numberAttr)({
              attributeId: "temperature",
              label: "Temperature",
              unit: "\xBAC",
              buckets: [
                (0, import_topo_map.rangeBucket)(null, 0, import_topo_map.marker.fromColor("#2afffe")),
                (0, import_topo_map.rangeBucket)(0, 5, import_topo_map.marker.fromColor("#26c576")),
                (0, import_topo_map.rangeBucket)(5, 10, import_topo_map.marker.fromColor("#7ac420")),
                (0, import_topo_map.rangeBucket)(10, 15, import_topo_map.marker.fromColor("#fffd2d")),
                (0, import_topo_map.rangeBucket)(15, 20, import_topo_map.marker.fromColor("#fd8b1f")),
                (0, import_topo_map.rangeBucket)(20, 25, import_topo_map.marker.fromColor("#fc5619")),
                (0, import_topo_map.rangeBucket)(25, null, import_topo_map.marker.fromColor("#ea2f00"))
              ],
              decimalPlaces: 0
            }),
            (0, import_topo_map.numberAttr)({
              attributeId: "electricalConductivity",
              label: "Electrical Conductivity",
              unit: "\xB5S/cm",
              buckets: [
                (0, import_topo_map.rangeBucket)(null, 25, import_topo_map.marker.mix("#c28000", "#ffff00", 1 - 25 / 250)),
                (0, import_topo_map.rangeBucket)(25, 50, import_topo_map.marker.mix("#c28000", "#ffff00", 1 - 50 / 250)),
                (0, import_topo_map.rangeBucket)(50, 75, import_topo_map.marker.mix("#c28000", "#ffff00", 1 - 75 / 250)),
                (0, import_topo_map.rangeBucket)(75, 100, import_topo_map.marker.mix("#c28000", "#ffff00", 1 - 100 / 250)),
                (0, import_topo_map.rangeBucket)(100, 125, import_topo_map.marker.mix("#c28000", "#ffff00", 1 - 125 / 250)),
                (0, import_topo_map.rangeBucket)(125, 150, import_topo_map.marker.mix("#c28000", "#ffff00", 1 - 150 / 250)),
                (0, import_topo_map.rangeBucket)(150, 200, import_topo_map.marker.mix("#c28000", "#ffff00", 1 - 200 / 250)),
                (0, import_topo_map.rangeBucket)(200, null, import_topo_map.marker.mix("#c28000", "#ffff00", 1 - 250 / 250))
              ],
              decimalPlaces: 0
            }),
            (0, import_topo_map.numberAttr)({
              attributeId: "ph",
              label: "pH",
              buckets: [
                (0, import_topo_map.rangeBucket)(null, 5, import_topo_map.marker.mix("#eef400", "#197fea", 0 / 11)),
                (0, import_topo_map.rangeBucket)(5, 5.5, import_topo_map.marker.mix("#eef400", "#197fea", 1 / 11)),
                (0, import_topo_map.rangeBucket)(5.5, 6, import_topo_map.marker.mix("#eef400", "#197fea", 2 / 11)),
                (0, import_topo_map.rangeBucket)(6, 6.5, import_topo_map.marker.mix("#eef400", "#197fea", 3 / 11)),
                (0, import_topo_map.rangeBucket)(6.5, 7, import_topo_map.marker.mix("#eef400", "#197fea", 4 / 11)),
                (0, import_topo_map.rangeBucket)(7, 7.5, import_topo_map.marker.mix("#eef400", "#197fea", 5 / 11)),
                (0, import_topo_map.rangeBucket)(7.5, 8, import_topo_map.marker.mix("#eef400", "#197fea", 6 / 11)),
                (0, import_topo_map.rangeBucket)(8, 8.5, import_topo_map.marker.mix("#eef400", "#197fea", 7 / 11)),
                (0, import_topo_map.rangeBucket)(8.5, 9, import_topo_map.marker.mix("#eef400", "#197fea", 8 / 11)),
                (0, import_topo_map.rangeBucket)(9, 9.5, import_topo_map.marker.mix("#eef400", "#197fea", 9 / 11)),
                (0, import_topo_map.rangeBucket)(9.5, 10, import_topo_map.marker.mix("#eef400", "#197fea", 10 / 11)),
                (0, import_topo_map.rangeBucket)(10, null, import_topo_map.marker.mix("#eef400", "#197fea", 11 / 11))
              ],
              decimalPlaces: 1
            }),
            // Data not yet ready for release - numberAttr({ attributeId: "alkalinity", label: "Alkalinity", "mg/L as CaCO3", buckets: "auto" }),
            // Data not yet ready for release - numberAttr({ attributeId: "uv", label: "UV", buckets: "auto" }),
            // Data not yet ready for release - numberAttr({ attributeId: "chlorophyllA", label: "Chlorophyll-A", "µg/L", buckets: "auto" }),
            (0, import_topo_map.numberAttr)({
              attributeId: "totalPhosphorus",
              label: "Total Phosphorus",
              unit: "mg P/L",
              buckets: phosphorousBuckets,
              decimalPlaces: 4
            }),
            (0, import_topo_map.numberAttr)({
              attributeId: "totalDissolvedPhosphorus",
              label: "Total Dissolved Phosphorus",
              unit: "mg P/L",
              buckets: phosphorousBuckets,
              decimalPlaces: 4
            }),
            (0, import_topo_map.numberAttr)({
              attributeId: "solubleReactivePhosphorus",
              label: "Soluble Reactive Phosphorus",
              unit: "mg P/L",
              buckets: [
                (0, import_topo_map.rangeBucket)(null, 15e-4, import_topo_map.marker.numeric(14 / 14, 120)),
                (0, import_topo_map.rangeBucket)(15e-4, 2e-3, import_topo_map.marker.numeric(13 / 14, 120)),
                (0, import_topo_map.rangeBucket)(2e-3, 3e-3, import_topo_map.marker.numeric(12 / 14, 120)),
                (0, import_topo_map.rangeBucket)(3e-3, 4e-3, import_topo_map.marker.numeric(11 / 14, 120)),
                (0, import_topo_map.rangeBucket)(4e-3, 5e-3, import_topo_map.marker.numeric(10 / 14, 120)),
                (0, import_topo_map.rangeBucket)(5e-3, 75e-4, import_topo_map.marker.numeric(9 / 14, 120)),
                (0, import_topo_map.rangeBucket)(75e-4, 0.01, import_topo_map.marker.numeric(8 / 14, 120)),
                (0, import_topo_map.rangeBucket)(0.01, 0.02, import_topo_map.marker.numeric(7 / 14, 120)),
                (0, import_topo_map.rangeBucket)(0.02, 0.03, import_topo_map.marker.numeric(6 / 14, 120)),
                (0, import_topo_map.rangeBucket)(0.03, 0.04, import_topo_map.marker.numeric(5 / 14, 120)),
                (0, import_topo_map.rangeBucket)(0.04, 0.05, import_topo_map.marker.numeric(4 / 14, 120)),
                (0, import_topo_map.rangeBucket)(0.05, 0.1, import_topo_map.marker.numeric(3 / 14, 120)),
                (0, import_topo_map.rangeBucket)(0.1, 0.2, import_topo_map.marker.numeric(2 / 14, 120)),
                (0, import_topo_map.rangeBucket)(0.2, 0.3, import_topo_map.marker.numeric(1 / 14, 120)),
                (0, import_topo_map.rangeBucket)(0.3, null, import_topo_map.marker.numeric(0 / 14, 120))
              ],
              decimalPlaces: 4
            }),
            (0, import_topo_map.stringAttr)({
              attributeId: "wfdPhosphorusStatus",
              label: "WFD Phosphorus Status",
              buckets: [
                (0, import_topo_map.lookupBucket)("High", import_topo_map.marker.fromColor("#27b6f3")),
                (0, import_topo_map.lookupBucket)("Good", import_topo_map.marker.fromColor("#27bf57")),
                (0, import_topo_map.lookupBucket)("Moderate", import_topo_map.marker.fromColor("#fffd2d")),
                (0, import_topo_map.lookupBucket)("Poor", import_topo_map.marker.fromColor("#f0a923")),
                (0, import_topo_map.lookupBucket)("Bad", import_topo_map.marker.fromColor("#df0012"))
              ]
            }),
            (0, import_topo_map.numberAttr)({
              attributeId: "totalAmmonia",
              label: "Total Ammonia",
              unit: "mg N/L",
              buckets: [
                (0, import_topo_map.rangeBucket)(null, 0.02, import_topo_map.marker.numeric(5 / 5, 200)),
                (0, import_topo_map.rangeBucket)(0.02, 0.05, import_topo_map.marker.numeric(4 / 5, 200)),
                (0, import_topo_map.rangeBucket)(0.05, 0.1, import_topo_map.marker.numeric(3 / 5, 200)),
                (0, import_topo_map.rangeBucket)(0.1, 0.2, import_topo_map.marker.numeric(2 / 5, 200)),
                (0, import_topo_map.rangeBucket)(0.2, 0.5, import_topo_map.marker.numeric(1 / 5, 200)),
                (0, import_topo_map.rangeBucket)(0.5, null, import_topo_map.marker.numeric(0 / 5, 200))
              ],
              decimalPlaces: 2
            }),
            (0, import_topo_map.numberAttr)({
              attributeId: "totalOxidisedNitrogen",
              label: "Total Oxidised Nitrogen",
              unit: "mg N/L",
              buckets: nitrateBuckets,
              decimalPlaces: 2
            }),
            (0, import_topo_map.numberAttr)({
              attributeId: "nitrate",
              label: "Nitrate",
              unit: "mg N/L",
              buckets: nitrateBuckets,
              decimalPlaces: 2
            }),
            (0, import_topo_map.numberAttr)({
              attributeId: "nitrite",
              label: "Nitrite",
              unit: "mg N/L",
              buckets: [
                (0, import_topo_map.rangeBucket)(null, 2e-4, import_topo_map.marker.numeric(8 / 8, 200)),
                (0, import_topo_map.rangeBucket)(2e-4, 5e-3, import_topo_map.marker.numeric(7 / 8, 200)),
                (0, import_topo_map.rangeBucket)(5e-3, 1e-3, import_topo_map.marker.numeric(6 / 8, 200)),
                (0, import_topo_map.rangeBucket)(1e-3, 0.02, import_topo_map.marker.numeric(5 / 8, 200)),
                (0, import_topo_map.rangeBucket)(0.02, 0.03, import_topo_map.marker.numeric(4 / 8, 200)),
                (0, import_topo_map.rangeBucket)(0.03, 0.04, import_topo_map.marker.numeric(3 / 8, 200)),
                (0, import_topo_map.rangeBucket)(0.04, 0.05, import_topo_map.marker.numeric(2 / 8, 200)),
                (0, import_topo_map.rangeBucket)(0.05, 0.06, import_topo_map.marker.numeric(1 / 8, 200)),
                (0, import_topo_map.rangeBucket)(0.06, null, import_topo_map.marker.numeric(0 / 8, 200))
              ],
              decimalPlaces: 4
            }),
            (0, import_topo_map.numberAttr)({
              attributeId: "silica",
              label: "Silica",
              unit: "mg SiO2/L",
              buckets: [
                (0, import_topo_map.rangeBucket)(null, 0.02, import_topo_map.marker.numeric(10 / 10, 30)),
                (0, import_topo_map.rangeBucket)(0.02, 0.1, import_topo_map.marker.numeric(9 / 10, 30)),
                (0, import_topo_map.rangeBucket)(0.1, 0.2, import_topo_map.marker.numeric(8 / 10, 30)),
                (0, import_topo_map.rangeBucket)(0.2, 0.3, import_topo_map.marker.numeric(7 / 10, 30)),
                (0, import_topo_map.rangeBucket)(0.3, 0.4, import_topo_map.marker.numeric(6 / 10, 30)),
                (0, import_topo_map.rangeBucket)(0.4, 0.5, import_topo_map.marker.numeric(5 / 10, 30)),
                (0, import_topo_map.rangeBucket)(0.5, 0.75, import_topo_map.marker.numeric(4 / 10, 30)),
                (0, import_topo_map.rangeBucket)(0.75, 1, import_topo_map.marker.numeric(3 / 10, 30)),
                (0, import_topo_map.rangeBucket)(1, 1.5, import_topo_map.marker.numeric(2 / 10, 30)),
                (0, import_topo_map.rangeBucket)(1.5, 2, import_topo_map.marker.numeric(1 / 10, 30)),
                (0, import_topo_map.rangeBucket)(2, null, import_topo_map.marker.numeric(0 / 10, 30))
              ],
              decimalPlaces: 2
            }),
            // Data not yet ready for release - numberAttr({ attributeId: "dissolvedOrganicCarbon", label: "Dissolved Organic Carbon", "mg C/L", buckets: "auto" }),
            (0, import_topo_map.numberAttr)({
              attributeId: "totalColiforms",
              label: "Total Coliforms",
              unit: "cfu/100 ml",
              buckets: [
                (0, import_topo_map.rangeBucket)(null, 500, import_topo_map.marker.numeric(7 / 7, 0)),
                (0, import_topo_map.rangeBucket)(500, 1e3, import_topo_map.marker.numeric(6 / 7, 0)),
                (0, import_topo_map.rangeBucket)(1e3, 2e3, import_topo_map.marker.numeric(5 / 7, 0)),
                (0, import_topo_map.rangeBucket)(2e3, 3e3, import_topo_map.marker.numeric(4 / 7, 0)),
                (0, import_topo_map.rangeBucket)(3e3, 4e3, import_topo_map.marker.numeric(3 / 7, 0)),
                (0, import_topo_map.rangeBucket)(4e3, 8e3, import_topo_map.marker.numeric(2 / 7, 0)),
                (0, import_topo_map.rangeBucket)(8e3, 16e3, import_topo_map.marker.numeric(1 / 7, 0)),
                (0, import_topo_map.rangeBucket)(16e3, null, import_topo_map.marker.numeric(0 / 7, 0))
              ],
              decimalPlaces: 0
            }),
            (0, import_topo_map.numberAttr)({
              attributeId: "eColi",
              label: "E-Coli",
              unit: "cfu/100 ml",
              buckets: [
                (0, import_topo_map.rangeBucket)(null, 500, import_topo_map.marker.numeric(6 / 6, 0)),
                (0, import_topo_map.rangeBucket)(500, 1e3, import_topo_map.marker.numeric(5 / 6, 0)),
                (0, import_topo_map.rangeBucket)(1e3, 2e3, import_topo_map.marker.numeric(4 / 6, 0)),
                (0, import_topo_map.rangeBucket)(2e3, 3e3, import_topo_map.marker.numeric(3 / 6, 0)),
                (0, import_topo_map.rangeBucket)(3e3, 4e3, import_topo_map.marker.numeric(2 / 6, 0)),
                (0, import_topo_map.rangeBucket)(4e3, 8e3, import_topo_map.marker.numeric(1 / 6, 0)),
                (0, import_topo_map.rangeBucket)(8e3, null, import_topo_map.marker.numeric(0 / 6, 0))
              ],
              decimalPlaces: 0
            }),
            (0, import_topo_map.numberAttr)({
              attributeId: "intestinalEnterococci",
              label: "Intestinal Enterococci",
              unit: "cfu/100 ml",
              buckets: [
                (0, import_topo_map.rangeBucket)(null, 200, import_topo_map.marker.numeric(5 / 5, 0)),
                (0, import_topo_map.rangeBucket)(200, 400, import_topo_map.marker.numeric(4 / 5, 0)),
                (0, import_topo_map.rangeBucket)(400, 800, import_topo_map.marker.numeric(3 / 5, 0)),
                (0, import_topo_map.rangeBucket)(800, 1600, import_topo_map.marker.numeric(2 / 5, 0)),
                (0, import_topo_map.rangeBucket)(1600, 3200, import_topo_map.marker.numeric(1 / 5, 0)),
                (0, import_topo_map.rangeBucket)(3200, null, import_topo_map.marker.numeric(0 / 5, 0))
              ],
              decimalPlaces: 0
            }),
            (0, import_topo_map.stringAttr)({
              attributeId: "bathingWaterQuality",
              label: "Bathing Water Quality",
              buckets: [
                (0, import_topo_map.lookupBucket)("Excellent", import_topo_map.marker.fromColor("#27b6f3")),
                (0, import_topo_map.lookupBucket)("Good", import_topo_map.marker.fromColor("#27bf57")),
                (0, import_topo_map.lookupBucket)("Less than Good", import_topo_map.marker.fromColor("#fffd2d"))
              ]
            })
          ]
        })
      ]
    })
  ]
});
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  FbaWindermere
});
//# sourceMappingURL=FbaWindermere.js.map
